"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTION_BASE_URL = exports.QA_BASE_URL = exports.INCHES_TO_CM = void 0;
exports.INCHES_TO_CM = 2.54;
exports.QA_BASE_URL = 'https://www.qa.saatchiart.com';
exports.PRODUCTION_BASE_URL = 'https://www.saatchiart.com';
